import { render, staticRenderFns } from "./mobile-card.vue?vue&type=template&id=2f2467ee&scoped=true&"
import script from "./mobile-card.vue?vue&type=script&lang=js&"
export * from "./mobile-card.vue?vue&type=script&lang=js&"
import style0 from "./mobile-card.vue?vue&type=style&index=0&id=2f2467ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2467ee",
  null
  
)

export default component.exports